import { usePermissions } from '@customerio/hydra-permissions/react';
import { useCurrentWorkspace } from '../context/current-workspace';
import { workspaceRootUrl } from '@/utils/navigation';
import { SafeNavigate } from '@/services/router/safe-navigate';

export default function Index() {
  const currentWorkspace = useCurrentWorkspace();
  const { hasPermission } = usePermissions();

  if (currentWorkspace == null) {
    if (hasPermission('account/billing/view') === true) {
      return <SafeNavigate to="settings/billing/your-plan" options={{ shouldReplaceHistoryEntry: true }} />;
    }

    return <SafeNavigate to="settings" options={{ shouldReplaceHistoryEntry: true }} />;
  }

  const path = `${workspaceRootUrl(currentWorkspace.id)}${window.location.search}`;
  return <SafeNavigate to={path} options={{ shouldReplaceHistoryEntry: true }} />;
}
